'use strict';

const { h } = require('phy');

const Slide = require('../carousel/slide');

const CouponCardAction = require('../../modules/coupons/views/coupon-card-action');
const OfferExpiry = require('../../modules/shared/views/offer/offer-expiry');
const OfferViewTerms = require('../../modules/shared/views/offer/offer-view-terms');

function Card({ routes, item, isTouch, sizes }) {
  const ExpiryElement = OfferExpiry({
    className: 'coupon-card-expiry',
    expires: item.expiryDateTime,
  });

  const ViewTermsElement = OfferViewTerms({
    routes,
    offerId: item.offerId,
    className: 'coupon-card-terms',
  });

  const child = h('.child', [
    ExpiryElement,
    CouponCardAction({
      offerId: item.offerId,
      routes,
    }),
    ViewTermsElement,
  ]);

  return Slide({
    routes,
    item,
    isTouch,
    sizes,
    className: 'card',
    child,
    tag: 'div',
    lazy: true,
  });
}

module.exports = Card;
